import { Paper } from '@mui/material'
import SearchBar from './SearchBar'
import PersonList from './PersonList'

export default function PersonSearch() {
  return (
    <Paper sx={{ width: '100%', my: 1, minHeight: '500px' }} elevation={0}>
      <SearchBar />
      <PersonList />
    </Paper>
  )
}
